'use client';
import { ReactNode, Suspense } from 'react';
import { LoadingScreen } from '@/components/ui/loading-screen';
import * as React from 'react';
import { useAppContext } from '@/context/app-context';

type Props = {
    children: ReactNode;
};

export default function AuthLayout({ children }: Props) {
    const { loading } = useAppContext();

    const fallback = (
        <div className="flex-1">
            <LoadingScreen />
        </div>
    );

    return (
        <div className="min-h-screen py-20 px-4 bg-black text-white dark overflow-x-hidden flex justify-center items-center">
            <Suspense fallback={fallback}>
                {loading ? fallback : children}
            </Suspense>
        </div>
    );
}
